import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageItem } from '@app/_models/images-manager/images-management.model';

@Component({
    selector: 'carousel-modal',
    templateUrl: 'carousel-modal.component.html',
    styleUrls: ['carousel-modal.component.scss'],
})
export class CarouselModalComponent {
    constructor(
        public dialogRef: MatDialogRef<CarouselModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { images: ImageItem[]; index: number }
    ) {}

    closeModal(): void {
        this.dialogRef.close();
    }
}
